import './TopNav.scss';
import { useCallback } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import useNavigationMenus from 'common/hooks/useMenus';
import { useCompareUrlWithProjectId, useNavigateWithProjectId } from 'common/hooks/route';
import { useParams } from 'react-router-dom';

export default function TopNav() {
  const { topMenuItems } = useNavigationMenus();
  const { compareUrl } = useCompareUrlWithProjectId();
  const { tab } = useParams();

  const navigate = useNavigateWithProjectId();

  const handleItemNavigation = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );

  return (
    <div className="top-nav-container">
      {topMenuItems.map((link) => (
        <Button
          rounded={null}
          key={link.route}
          fillMode="link"
          size={'large'}
          onClick={() => handleItemNavigation(link.route as string)}
          className={
            compareUrl(link.route as string, { startsWith: !!tab }) ? 'top-nav-active-button' : ''
          }
        >
          {link.text}
        </Button>
      ))}
    </div>
  );
}
